import React, { useEffect, useRef, useState } from 'react'
import '../../assets/style/main.css'
import './style.scss'
import COVER from '../../assets/images/icons/IdentificationCard.png'
import CHECKED_ICON from '../../assets/images/icons/checked.png'
import { Base_API } from '../../_actions/matcher'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import SignIn_Navbar from '../../components/SignIn_Navbar'
import { EncryptedText } from '../../utils/Encryption'

function SignUp_Overview() {
    let onceMount = useRef(true);
    let [isSkip, setIsSkip] = useState(false);

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false;
        }
    }, [])

    const pageInit = async() => {
        await checkCurrentURL();
        isPageLoading(false);
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let pathname = location.pathname;
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));

            // check for skip register
            let pathname2 = String(location.pathname).toLowerCase().replace(Base_API.pathWeb, '');
            if(pathname2 === '/n-health/kyc/overview-2' || pathname2 === '/n-health/kyc/overview-2')
            {
                setIsSkip(false); 
            }else
            {
                setIsSkip(true);  
            }

            resolve();
        })
    }

    const onSubmit = (type) => {
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS, EncryptedText(type)) 
        let pathname = String(location.pathname).toLowerCase().replace(Base_API.pathWeb, '');

        // KYC
        if(pathname === '/n-health/kyc/overview-2' || pathname === '/n-health/kyc/overview-2')
        {
            localStorage.setItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP, EncryptedText('kyc'))
            if(type === 'idcard')
            {
                location.href = `${Base_API.pathWeb}/n-health/kyc/idcard-ocr`;
            }else
            {
                location.href = `${Base_API.pathWeb}/n-health/kyc/face-ocr`; 
            }
        }
        // Sign-Up
        else
        {
            localStorage.setItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP, EncryptedText('register'))
            if(type === 'idcard')
            {
                location.href = `${Base_API.pathWeb}/n-health/signup/idcard-ocr`;
            }else
            {
                location.href = `${Base_API.pathWeb}/n-health/signup/forminfo`; 
            }
        }
    }

    const onSkip = () => {
        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_CAPTURE_IDCARD);
        // ข้ามได้เฉพาะ register
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS, EncryptedText('idcard')) 
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP, EncryptedText('register'))
        // Sign-Up
        location.href = `${Base_API.pathWeb}/n-health/signup/forminfo`; 
    }

    return (
        <div className="sgnup-ovrw-con">
            <h2 className='title'>
                เลือกถ่ายรูปบัตรประชาชน หรือ พาสปอร์ต
            </h2>
            <p className="sub-title">
                กรุณาเตรียมบัตรประชาชน หรือ พาสปอร์ต<br/>เพื่อถ่ายรูปในขั้นตอนถัดไป
            </p>
            <img className="cover" src={COVER} />
            <ul>
                <li>
                    <img src={CHECKED_ICON} />
                    <p>ถือโทรศัพท์องคุณไว้เหนือบัตรในที่ที่มีแสงสว่างเพียงพอ โดยต้องสามารถมองเห็นข้อมูลได้ชัดเจน</p>
                </li>
                <li>
                    <img src={CHECKED_ICON} />
                    <p>การลงทะเบียนยืนยันตัวตนช่วยยกระดับความปลอดภัยในการใช้งานของท่าน</p>
                </li>
            </ul>

            <div className="btn-group">
                <button className='card' onClick={() => onSubmit('idcard')}>
                    ถ่ายรูปบัตรประชาชน
                </button>
                <p className="mid">หรือ</p>
                <button className='passport' onClick={() => onSubmit('passport')}>
                    ถ่ายรูปพาสปอร์ต
                </button>
                {isSkip &&
                    <button className='passport' onClick={() => onSkip()}>
                        ข้ามขั้นตอนนี้
                    </button>
                }
            </div>

            <PageLoader />
            <SignIn_Navbar canClose={false}/>
        </div>
    )
}

export default SignUp_Overview